import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = { class: "hidden md:flex w-20" }
const _hoisted_3 = { class: "flex flex-row flex-1" }
const _hoisted_4 = { class: "w-full md:text-left md:w-1/6" }
const _hoisted_5 = { class: "text-headings-gray md:hidden mb-2" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "w-full flex flex-row justify-between mb-5 md:hidden" }
const _hoisted_8 = { class: "flex flex-col md:w-1/2" }
const _hoisted_9 = { class: "text-headings-gray mb-2" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "flex flex-col md:w-1/2" }
const _hoisted_12 = { class: "text-headings-gray mb-2" }
const _hoisted_13 = { class: "hidden md:flex flex-col md:align-middle md:w-1/6" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "hidden md:flex flex-col md:align-middle md:w-1/6" }
const _hoisted_16 = { class: "md:m-auto" }
const _hoisted_17 = { class: "w-full flex flex-col md:w-1/6 md:flex-row" }
const _hoisted_18 = { class: "h-8 m-auto px-3 md:text-light font-semibold capitalize bg-gray-300 rounded-full leading-8" }
const _hoisted_19 = { class: "w-full flex flex-col md:w-1/6 md:flex-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-place text-big mr-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-place text-big mr-2" }, null, -1)
const _hoisted_22 = { class: "w-full flex flex-col md:w-1/6 md:flex-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-label text-big mr-2" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-label text-big mr-2" }, null, -1)
const _hoisted_25 = { class: "hidden md:flex flex-row justify-end w-20" }
const _hoisted_26 = ["checked"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "block w-full bg-gray-200 h-0.5 my-4" }, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:flex lg:flex-col lg:w-20" }, null, -1)
const _hoisted_31 = { class: "mb-5 mr-10 min-w-1/8" }
const _hoisted_32 = { class: "mb-5 mr-10 min-w-1/8" }
const _hoisted_33 = { class: "text-headings-gray font-bold my-auto" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = { class: "flex flex-col min-w-1/8" }
const _hoisted_45 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_46 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_47 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_48 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_49 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_50 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_51 = { class: "flex flex-row w-full justify-between mb-2" }
const _hoisted_52 = { class: "text-headings-gray font-bold mr-5" }
const _hoisted_53 = {
  key: 1,
  class: "flex flex-row mb-2"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", { class: "hidden lg:flex lg:flex-col lg:w-20" }, null, -1)
const _hoisted_55 = { class: "flex flex-row flex-1" }
const _hoisted_56 = { class: "w-1/12 font-bold" }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/6" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_expand_button = _resolveComponent("expand-button")!
  const _component_default_button = _resolveComponent("default-button")!
  const _component_return_parcel_details = _resolveComponent("return-parcel-details")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "flex flex-col justify-center bg-white text-light text-black rounded p-5 cursor-pointer text-justify relative mb-2 md:px-10",
      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded))
    }, [
      _createElementVNode("input", {
        type: "checkbox",
        class: "absolute top-6 right-6 md:hidden",
        value: _ctx.isChecked,
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('checkParcel', _ctx.returnParcel?.id)), ["stop"]))
      }, null, 8, _hoisted_1),
      _createElementVNode("div", {
        class: "flex flex-col md:flex-row md:text-center md:align-middle justify-center md:justify-between",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_expand_button, {
            class: "my-auto",
            modelValue: _ctx.isExpanded,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isExpanded) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("strong", _hoisted_5, _toDisplayString(_ctx.$t("return_parcels.list.item.labels.id")), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "text-primary-blue font-bold mb-2",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
                _ctx.valid ? (_ctx.showDetails = true) : (_ctx.isExpanded = !_ctx.isExpanded)
              ), ["stop"]))
              }, _toDisplayString(_ctx.$t("return_parcels.list.item.return_id", {
                  id: _ctx.returnParcel.id,
                })), 1)
            ]),
            _createElementVNode("div", {
              class: "text-primary-blue font-bold mb-2",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openTrackingUrl(_ctx.returnParcel.tracking_url)), ["stop"]))
            }, _toDisplayString(_ctx.returnParcel.tracking_number), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("strong", _hoisted_9, _toDisplayString(_ctx.$t("return_parcels.list.item.labels.supplier")), 1),
              _createElementVNode("img", {
                src: 
                _ctx.returnParcel
                  ? _ctx.importImage(_ctx.returnParcel?.supplier?.full_name_standard)
                  : ''
              ,
                alt: 
                _ctx.returnParcel ? _ctx.returnParcel?.supplier?.full_name_standard : ''
              
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.$t("return_parcels.list.item.labels.created_at")), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.moment(_ctx.returnParcel.created_at, "YYYY-MM-DD HH:mm").format(
                  "DD.MM.YYYY"
                )), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              class: "w-1/2 m-auto",
              src: 
              _ctx.returnParcel
                ? _ctx.importImage(_ctx.returnParcel?.supplier?.full_name_standard)
                : ''
            ,
              alt: 
              _ctx.returnParcel ? _ctx.returnParcel?.supplier?.full_name_standard : ''
            
            }, null, 8, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.moment(_ctx.returnParcel.created_at, "YYYY-MM-DD HH:mm").format(
                "DD.MM.YYYY HH:mm"
              )), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.valid ? _ctx.$t("general.created") : _ctx.$t("general.failed")), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_ctx.returnParcel.tracking_url)
              ? (_openBlock(), _createBlock(_component_default_button, {
                  key: 0,
                  type: "outline",
                  class: "md:hidden",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.openTrackingUrl(_ctx.returnParcel.tracking_url)), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _hoisted_20,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("return_parcels.list.item.buttons.tracking")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.returnParcel.tracking_url)
              ? (_openBlock(), _createBlock(_component_default_button, {
                  key: 1,
                  type: "empty",
                  class: "hidden md:flex md:m-auto",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.openTrackingUrl(_ctx.returnParcel.tracking_url)), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("return_parcels.list.item.buttons.tracking")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            (_ctx.returnParcel.is_label_attached)
              ? (_openBlock(), _createBlock(_component_default_button, {
                  key: 0,
                  type: "outline",
                  class: "mb-2 md:hidden",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (
              _ctx.downloadService.getLabel(_ctx.returnParcel.id.toString())
            ), ["prevent"])),
                  "is-loading": _ctx.isDownloading
                }, {
                  default: _withCtx(() => [
                    _hoisted_23,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("return_parcels.list.item.buttons.label")), 1)
                  ]),
                  _: 1
                }, 8, ["is-loading"]))
              : _createCommentVNode("", true),
            (_ctx.returnParcel.is_label_attached)
              ? (_openBlock(), _createBlock(_component_default_button, {
                  key: 1,
                  type: "empty",
                  class: "mb-2 hidden md:flex md:m-auto",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (
              _ctx.downloadService.getLabel(_ctx.returnParcel.id.toString())
            ), ["prevent"])),
                  "is-loading": _ctx.isDownloading
                }, {
                  default: _withCtx(() => [
                    _hoisted_24,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("return_parcels.list.item.buttons.label")), 1)
                  ]),
                  _: 1
                }, 8, ["is-loading"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("input", {
            type: "checkbox",
            checked: _ctx.isChecked,
            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('checkParcel', _ctx.returnParcel?.id)))
          }, null, 40, _hoisted_26)
        ])
      ]),
      (_ctx.isExpanded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _hoisted_28,
            (_ctx.valid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", {
                      class: "text-primary-blue font-bold mb-2",
                      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (
              _ctx.$router.push({
                name: 'parcels.list',
                query: {
                  search: `${_ctx.returnParcel.outbound_parcel_id}`,
                },
              })
            ), ["stop","prevent"]))
                    }, _toDisplayString(_ctx.$t("parcels.list.item.parcel_id", {
                id: _ctx.returnParcel.outbound_parcel_id,
              })), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t("return_parcels.list.item.address")), 1),
                    (_ctx.returnParcel?.receiver_address?.company_name)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "mb-1",
                          innerHTML: `${_ctx.returnParcel?.receiver_address?.company_name}<br />`
                        }, null, 8, _hoisted_34))
                      : _createCommentVNode("", true),
                    (_ctx.returnParcel?.receiver_address?.name)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "mb-1",
                          innerHTML: `${_ctx.returnParcel?.receiver_address?.name}<br />`
                        }, null, 8, _hoisted_35))
                      : _createCommentVNode("", true),
                    (_ctx.returnParcel?.receiver_address?.address_first_line)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: "mb-1",
                          innerHTML: 
              `${_ctx.returnParcel?.receiver_address?.address_first_line}<br />`
            
                        }, null, 8, _hoisted_36))
                      : _createCommentVNode("", true),
                    (_ctx.returnParcel?.receiver_address?.address_second_line)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 3,
                          class: "mb-1",
                          innerHTML: 
              `${_ctx.returnParcel?.receiver_address?.address_second_line}<br />`
            
                        }, null, 8, _hoisted_37))
                      : _createCommentVNode("", true),
                    (_ctx.returnParcel?.receiver_address?.zip)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 4,
                          class: "mb-1",
                          innerHTML: `${_ctx.returnParcel?.receiver_address?.zip} `
                        }, null, 8, _hoisted_38))
                      : _createCommentVNode("", true),
                    (_ctx.returnParcel?.receiver_address?.city)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 5,
                          class: "mb-1",
                          innerHTML: `${_ctx.returnParcel?.receiver_address?.city} `
                        }, null, 8, _hoisted_39))
                      : _createCommentVNode("", true),
                    (_ctx.returnParcel?.receiver_address?.state)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 6,
                          class: "mb-1",
                          innerHTML: `${_ctx.returnParcel?.receiver_address?.state} `
                        }, null, 8, _hoisted_40))
                      : _createCommentVNode("", true),
                    (_ctx.returnParcel?.receiver_address?.country?.name)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 7,
                          class: "mb-1",
                          innerHTML: `${_ctx.returnParcel?.receiver_address?.country?.name} `
                        }, null, 8, _hoisted_41))
                      : _createCommentVNode("", true),
                    (_ctx.returnParcel?.receiver_address?.phone)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 8,
                          class: "mb-1",
                          innerHTML: `<br />${_ctx.returnParcel?.receiver_address?.phone}`
                        }, null, 8, _hoisted_42))
                      : _createCommentVNode("", true),
                    (_ctx.returnParcel?.receiver_address?.email)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 9,
                          class: "mb-1",
                          innerHTML: `<br />${_ctx.returnParcel?.receiver_address?.email} `
                        }, null, 8, _hoisted_43))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t("return_parcels.list.item.created")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.moment(_ctx.returnParcel.created_at, "YYYY-MM-DD HH:mm").format(
                  "DD.MM.YYYY HH:mm"
                )), 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("return_parcels.list.item.weight")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("return_parcels.details.weight_value", {
                  weight: _ctx.returnParcel?.weight || "-",
                })), 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t("return_parcels.list.item.currency")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.returnParcel.price_currency || "-"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("return_parcels.list.item.shipper_reference")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.returnParcel.shipper_reference || "-"), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.valid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.$t("bulk_parcels.errors.item.details.description")), 1),
                    _createElementVNode("p", {
                      class: "w-3/4",
                      innerHTML: _ctx.prepareErrors(_ctx.returnParcel.validation_errors)
                    }, null, 8, _hoisted_57),
                    _hoisted_58
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_modal, {
      modelValue: _ctx.showDetails,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showDetails) = $event)),
      "hide-buttons": true
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("return_parcels.list.item.return_id", { id: _ctx.returnParcel.id })), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_return_parcel_details, {
          "return-parcel-id": _ctx.returnParcel.id
        }, null, 8, ["return-parcel-id"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}